import {
  Activity,
  Archive,
  ClipboardCheck,
  PackageSearch,
  ScanLine,
  Settings,
  ShieldCheck,
  Tag,
  Truck,
  UserPlus,
  type LucideIcon,
} from 'lucide-react'

/**
 * Workflow icons, from a fixed set.
 *
 * Deliberately not a dynamic lookup across the whole icon library. The old app
 * did `Icons[iconName]` with a `@ts-ignore`, which defeats tree-shaking — the
 * entire lucide set ends up in the bundle — and silently renders a fallback if
 * a name is ever mistyped. An explicit map keeps the bundle small and makes the
 * admin picker and the renderer impossible to disagree.
 */
export const WORKFLOW_ICONS = {
  Scan: ScanLine,
  PackageSearch,
  UserPlus,
  ClipboardCheck,
  Truck,
  ShieldCheck,
  Archive,
  Tag,
  Settings,
  Activity,
} satisfies Record<string, LucideIcon>

export type WorkflowIconName = keyof typeof WORKFLOW_ICONS

export const WORKFLOW_ICON_NAMES = Object.keys(WORKFLOW_ICONS) as WorkflowIconName[]

export function WorkflowIcon({
  name,
  className,
}: {
  name?: string | undefined
  className?: string | undefined
}) {
  const Icon = (name !== undefined && name in WORKFLOW_ICONS
    ? WORKFLOW_ICONS[name as WorkflowIconName]
    : Activity) as LucideIcon
  return <Icon className={className} aria-hidden="true" />
}
